export default __webpack_public_path__ + "static/media/ic_staff.5f0f34ea.svg";